import LearnTube from "../../assets/LearnTube.png";
import Formify from "../../assets/Formify.png";
import Breakfree from "../../assets/BreakFree.png";
import Infinite from "../../assets/Infinite-scrolling.png";
import Calendar from "../../assets/Calendar.png";
import StudyBuddy from "../../assets/StudyBuddy.png";
import Wisdoma from "../../assets/Wisdoma.png";
import TrackIt from "../../assets/TrackIt.png";

export const ProjectsList = [
  {
    name: "Silk",
    description:
      "AI-powered platform that generates personalized, structured courses with real-time interaction via SocketIO and built-in analytics",
    loomLink:
      "https://www.loom.com/embed/0034f7117fb94837903902124f1ba0c0?sid=98e23aab-20cf-463f-9d15-bdef50b1d179",
    projectLink: "https://silk.omgate.dev/",
    sourceLink: "https://github.com/omgate23/silk",
    tech: "ReactJS, Tailwind CSS, Gemini AI, Flask, SocketIO",
  },
  {
    name: "TrackIt",
    description:
      "AI-powered task scheduler with Google Calendar-like interface. Onboarded 50+ users managing 180+ tasks",
    src: TrackIt,
    projectLink: "https://get-trackit.vercel.app/",
    sourceLink: "https://github.com/omgate23/track-it-app",
    tech: "Next.js, Firebase, Gemini AI",
  },
  {
    name: "VideoQuery",
    description:
      "Video search tool that enables users to locate key moments using VectorDB and Ollama's LLaVA vision model",
    projectLink: "https://www.youtube.com/watch?v=I32DqHQZPgs",
    sourceLink: "https://github.com/omgate23/video-query",
    tech: "ReactJS, Flask, VectorDB, FFmpeg, Ollama",
  },
  {
    name: "Wisdoma",
    description: "Your Notes Visualized through Knowledge Graphs",
    src: Wisdoma,
    projectLink: "https://getwisdoma.vercel.app/",
    sourceLink: "https://github.com/omgate23/wisdoma",
  },
  {
    name: "BreakFree",
    description:
      "Runner-up at Grafbase × Hashnode GraphQL Hackathon (600+ participants). Social media monitoring extension",
    src: Breakfree,
    projectLink: "https://get-break-free.vercel.app/",
    sourceLink: "https://github.com/omgate23/breakfree",
  },
  {
    name: "LearnTube",
    description:
      "Unlock the Power of YouTube Learning with Our Course-Boosting App!",
    src: LearnTube,
    projectLink: "https://getlearntube.vercel.app/",
    sourceLink: "https://github.com/omgate23/learntube",
  },
  {
    name: "Calendar",
    description: "A calendar app for all your scheduling needs.",
    src: Calendar,
    projectLink: "https://calendar-pro-c3vm.vercel.app/",
    sourceLink: "https://github.com/omgate23/calendar-pro",
  },
  {
    name: "React Intersection Observer",
    description: "An npm package for intersection observer",
    src: Infinite,
    projectLink: "https://github.com/omgate23/intersection-observer-react/",
    sourceLink: "https://github.com/omgate23/intersection-observer-react",
  },
  {
    name: "StudyBuddy",
    description: "An extension for your distraction free studies",
    src: StudyBuddy,
    projectLink:
      "https://drive.google.com/file/d/1_2E1I4UtQ4avU80ehg6OCtjEXCgGhM_E/view?usp=sharing",
    sourceLink: "https://github.com/omgate23/padhle-mere-bhai",
  },
  {
    name: "Formify",
    description: "Swiftly sculpt your ideas with our effortless form creator.",
    src: Formify,
    projectLink: "https://formifypro.vercel.app/",
    sourceLink: "https://github.com/omgate23/formbuilder",
  },
];
